import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 2c1.917 0 3.644.776 4.747 2H25a2 2 0 0 1 1.994 1.85L27 6v21a2 2 0 0 1-1.85 1.994L25 29H7a2 2 0 0 1-1.995-1.85L5 27V6a2 2 0 0 1 1.85-1.995L7 4h4.253c1.103-1.224 2.83-2 4.747-2m-5.848 4H7v21h18V6h-3.152q.113.42.142.867l.01.3V8a1 1 0 0 1-.883.993L21 9H11a1 1 0 0 1-.993-.883L10 8v-.833q.001-.453.086-.884zm1.555 12.793-.094-.083a1 1 0 0 0-1.32 1.497l1.042 1.043-1.042 1.043-.083.094a1 1 0 0 0 1.497 1.32l1.043-1.042 1.043 1.042.094.083a1 1 0 0 0 1.32-1.497l-1.042-1.043 1.042-1.043.083-.094a1 1 0 0 0-1.497-1.32l-1.043 1.042zM16 12a1 1 0 0 1 .083 1.32l-.083.094-2.793 2.793a1 1 0 0 1-1.32.083l-.094-.083-1.5-1.5a1 1 0 0 1 1.32-1.497l.094.083.793.792L14.586 12A1 1 0 0 1 16 12m-3.952-5.32C12.344 5.193 13.972 4 16 4l.216.005.212.013c1.896.16 3.358 1.37 3.55 2.822l.016.16h-7.989l.017-.16z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSurveys = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSurveys);
export default Memo;
